import styleInject from 'style-inject';
import reset from './reset.css';
import font from './font.css';

export const setupReset = (includeBaseFont = false) => {
  const styles = includeBaseFont ? `${reset}\n${font}` : reset;
  styleInject(styles, { insertAt: 'top' });
};
